export const environment = {
  production: true,
  wsUrl: 'wss://zugwerk.serabi.de/ws',
  keycloakUrl: 'https://keycloak.geschenker.net/auth/realms/zugwerk',
  keycloakClientId: 'zugwerk-frontend',
  glitchtipDsn: 'https://3064f441ab174af3be231150e2197835@errors.serabi.de/3',
};
